import React from 'react';

export default function MoreStoriesNotice() {
  return (
    <aside className="bg-[#0b1423] px-4 pb-20 text-white sm:px-6 sm:pb-28 lg:px-8" aria-label="More case studies">
      <div className="mx-auto max-w-7xl rounded-[2rem] border border-[#c8b6ff]/30 bg-[#19283d] px-6 py-8 sm:px-10 sm:py-10">
        <span className="inline-block rounded-full bg-[#c8b6ff] px-3 py-1 text-xs font-bold uppercase tracking-wider text-[#0b1423]">
          Coming soon
        </span>
        <h2 className="mt-5 text-2xl font-black tracking-tight sm:text-3xl">More customer case studies are on the way.</h2>
        <p className="mt-3 max-w-2xl leading-relaxed text-slate-300">
          90&apos;s Nails is the first story we&apos;re sharing here. Check back for more examples of the local businesses we work with.
        </p>
      </div>
    </aside>
  );
}